export default __webpack_public_path__ + "static/hpay-icon-3a5caa08666d045b360b5c694e970d60.svg";